export default function useScrollTo() {
  const scrollTo = function (elementId) {
    document.getElementById(elementId)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  return { scrollTo };
}
